"use strict"

/**
 * Determine and return a fallback image to load
 *
 * @type {string}
 */

export default class FallbackImageManager {
  static getFallBackImage(parent, posterFallbackImage, landscapeFallbackImage) {
    let parentWidth = parent.offsetWidth
    let parentHeight = parent.offsetHeight

    if (parentWidth > parentHeight) {
      return landscapeFallbackImage
    } else {
      return posterFallbackImage
    }
  }
}
